import Edital from '../../views/admin/concursos/edital'
import SalvarEdital from '../../views/admin/concursos/edital/Save'
import Habilitados from '../../views/admin/concursos/edital/Habilitados'
import PreHabilitados from '../../views/admin/concursos/edital/PreHabilitados'
import Nomeados from '../../views/admin/concursos/acompanhamento/Nomeados'
import Acompanhamento from '../../views/admin/concursos/acompanhamento'
import AcompanhamentoDetalhes from '../../views/admin/concursos/acompanhamento/Details'
import AcompanhamentoDetalhesCargo from '../../views/admin/concursos/acompanhamento/DetailsCargo'

export const concursos = [
  {
    name: 'editais',
    path: 'concursos/edital',
    component: Edital,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'salvar_edital',
    path: 'concursos/edital/salvar',
    component: SalvarEdital,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'habilitados',
    path: 'concursos/habilitados/',
    component: Habilitados,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'pre_habilitados',
    path: 'concursos/pre-habilitados/',
    component: PreHabilitados,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'nomeados',
    path: 'concursos/nomeados/',
    component: Nomeados,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'acompanhamento',
    path: 'concursos/acompanhamento',
    component: Acompanhamento,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'acompanhamento_detalhes',
    path: 'concursos/acompanhamento/detalhes/:edital_id',
    component: AcompanhamentoDetalhes,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'acompanhamento_detalhes_cargo',
    path: 'concursos/acompanhamento/detalhes/cargo/:edital_id/:cargo_id',
    component: AcompanhamentoDetalhesCargo,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/admin/concursos.js